
import styles from "./PartSurveyItemUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useState } from "react";


import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { ChangeDefendant } from "service/SurveyService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItemUsed = ({ item, item_selected, index, setRender }) => {
  const { t } = useTranslation('common')


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const [text, setText] = useState('');


    const handleChange = (event) => {
        setText(event.target.value);
    };

    const [defendantsData, setDefendantsData] = useState([]);

    const handleFileAndDefendantChange = (event, defendantId) => {
        const file = event.target.files[0]; 

        setDefendantsData(prevData => [
            ...prevData,
            { file, defendantId }, 
        ]);
    };


    const handleSliderChange = (event, defendantId) => {
        const value = event.target.value; 

        setDefendantsData(prevData => {
            const existingDefendant = prevData.find(data => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map(data =>
                    data.defendantId === defendantId ? { ...data, sliderValue: value } : data
                );
            } else {
                return [...prevData, { defendantId, sliderValue: value }];
            }
        });
    };


    const handleSelectChange = (event, defendantId) => {
        const value = event.target.value; 

        setDefendantsData(prevData => {
            const existingDefendant = prevData.find(data => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map(data =>
                    data.defendantId === defendantId ? { ...data, sequencesSelectedNumber: value } : data
                );
            } else {
                return [...prevData, { defendantId, sequencesSelectedNumber: value }];
            }
        });
    };


    const handleTextChange = (event, defendantId) => {
        const value = event.target.value; 


        setDefendantsData(prevData => {
            const existingDefendant = prevData.find(data => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map(data =>
                    data.defendantId === defendantId ? { ...data, textValue: value } : data

                );
            } else {
                return [...prevData, { defendantId, textValue: value }];
            }
        });
    };

    const handleNumericInputChange = (event, defendantId) => {
        const value = event.target.value;

        const numericValue = isNaN(value) ? '' : value;

        setDefendantsData(prevData => {
            const existingDefendant = prevData.find(data => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map(data =>
                    data.defendantId === defendantId ? { ...data, type_input_int: numericValue } : data
                );
            } else {
                return [...prevData, { defendantId, type_input_int: numericValue }];
            }
        });
    };
    const handleTextInputChange = (event, defendantId) => {
        const value = event.target.value;

        setDefendantsData(prevData => {
            const existingDefendant = prevData.find(data => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map(data =>
                    data.defendantId === defendantId ? { ...data, type_input_txt: value } : data
                );
            } else {
                return [...prevData, { defendantId, type_input_txt: value }];
            }
        });
    };
    const handleCheckboxChange = (defendantId) => {
        setDefendantsData((prevData) => {
            const existingDefendant = prevData.find((data) => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map((data) =>
                    data.defendantId === defendantId ? { ...data, isChecked: !data.isChecked } : data
                );
            } else {
                return [...prevData, { defendantId, isChecked: true }];
            }
        });
    };

    const handleCheckboxChangeOne = (defendantId) => {
        setDefendantsData((prevData) => {
            const existingDefendant = prevData.find((data) => data.defendantId === defendantId);

            if (existingDefendant) {
                return prevData.map((data) =>
                    data.defendantId === defendantId
                        ? { ...data, isChecked: true } 
                        : { ...data, isChecked: false } 
                );
            } else {
                return prevData.map((data) => ({ ...data, isChecked: false })) 
                    .concat({ defendantId, isChecked: true }); 
            }
        });
    };

    const handleSubmit = (id) => {

        if (item.type_defendant === "fileUpload" && !defendantsData.some(data => data.file)) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, Загрузите файл перед отправкой.",
                type: "error",
            });
            return;
        }
        try {

            const formData = new FormData();


            const defendantArray = defendantsData.map(row => ({
                defendant: row.defendantId,
                rdefendant: row.sliderValue || null,
                sequences_selectedNumber: row.sequencesSelectedNumber || null,
                free_response: row.textValue || null,
                type_input_int: row.type_input_int || null,
                type_input_txt: row.type_input_txt || null,
                right_defendant: row.isChecked || false,


            }));
            formData.append('defendant_arr', JSON.stringify(defendantArray));
            defendantsData.forEach((row, index) => {
                if (row.file) {
                    formData.append(`file[${index}]`, row.file);
                }
            });


            ChangeDefendant(id, formData);
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }

    };


    const numOptions = item.defendant_part_survey.length;
    return (


        <div className={styles.defendant_card_selection}>

            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.defendant_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {Number(item_selected) !== Number(item.id) &&
                    <div className={styles.defendant_card_selection_body_defendant}>
                        {item.defendant_part_survey.map((defendant, index) => (
                            <>

                                <div style={{ width: '100%' }}>
                                    {(item.type_defendant !== "freeTextDefendant" && item.type_defendant !== "infoText" && item.type_defendant !== 'fileUpload') ? (
                                        <div className={styles.defendant_card_header}>


                                            {(item.type_defendant === 'sequenceOrdering') &&
                                                <>
                                                    <DraftContent draftData={defendant.title} />
                                                    <select
                                                        className={styles.point_check_num_text}
                                                        value={defendantsData.find(data => data.defendantId === defendant.id)?.sequencesSelectedNumber}
                                                        onChange={(e) => handleSelectChange(e, defendant.id)}
                                                    >
                                                        <option key={0} value={0}>{"Выберите последовательность"}</option>
                                                        {

                                                            Array.from({ length: numOptions }, (_, index) => index + 1).map(number => (
                                                                <option key={number} value={number}>{number}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </>
                                            }
                                            {(item.type_defendant === 'slider') &&
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                    <div>
                                                        <h4 >{defendant.type_input_txt}</h4>

                                                    </div>
                                                    <div className={styles.slider_min_max}>

                                                        <input
                                                            id="slider"
                                                            type="range"
                                                            min={Math.min(Number(defendant.min_len), Number(defendant.max_len))}
                                                            max={Math.max(Number(defendant.min_len), Number(defendant.max_len))}
                                                            value={defendantsData.find(data => data.defendantId === defendant.id)?.sliderValue || Math.min(Number(defendant.min_len), Number(defendant.max_len))}
                                                            onChange={(event) => handleSliderChange(event, defendant.id)}
                                                            style={{ width: '100%' }}
                                                        />
                                                        <span className={styles.slider_min_max_res}>
                                                            {
                                                                defendantsData.find(data => data.defendantId === defendant.id)?.sliderValue || Math.min(Number(defendant.min_len), Number(defendant.max_len))
                                                            }
                                                        </span>

                                                    </div>
                                                </div>
                                            }
                                            {(item.type_defendant === 'numericInput') &&
                                                <input
                                                    type="number"
                                                    value={defendantsData.find(data => data.defendantId === defendant.id)?.type_input_int} 
                                                    onChange={(e) => handleNumericInputChange(e, defendant.id)} 
                                                    style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                    placeholder={t('auto.components_partsurveyitemused.k2')}
                                                />
                                            }

                                            {(item.type_defendant === 'textInput') &&
                                                <input
                                                    type="text"
                                                    value={defendantsData.find(data => data.defendantId === defendant.id)?.type_input_txt} 
                                                    onChange={(e) => handleTextInputChange(e, defendant.id)} 
                                                    style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                    placeholder={t('tests.taking.enter_text')}
                                                />
                                            }
                                            {(item.type_defendant === 'singleSelection') &&
                                                <>
                                                    <input
                                                        type="radio"
                                                        id={`defendant-${defendant.id}`}
                                                        checked={defendantsData.find(data => data.defendantId === defendant.id)?.isChecked || false} 
                                                        onChange={() => handleCheckboxChangeOne(defendant.id)} 
                                                    />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            }
                                            {(item.type_defendant === 'multipleSelection') &&
                                                <>
                                                    <input
                                                        type="checkbox"
                                                        id={`defendant-${defendant.id}`}
                                                        checked={defendantsData.find(data => data.defendantId === defendant.id)?.isChecked || false} 
                                                        onChange={() => handleCheckboxChange(defendant.id)} 
                                                    />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            }

                                        </div>
                                    ) : (
                                        <>
                                            {item.type_defendant === "freeTextDefendant" && (
                                                <div className={styles.defendant_card_header}>
                                                    <div className={styles.defendant_card_second_div} >
                                                        <textarea
                                                            value={defendantsData.find(data => data.defendantId === defendant.id)?.textValue}
                                                            className={styles.defendant_card_header_textarea}
                                                            onChange={(e) => handleTextChange(e, defendant.id)}
                                                            maxLength={item.max_len}
                                                            rows="4"
                                                            cols="50"
                                                            placeholder={t('tests.taking.enter_text')}
                                                        />
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>

                                                            <span>{String(defendantsData.find(data => data.defendantId === defendant.id)?.textValue || '').length}

                                                                / {item.max_len}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            )}
                                            {item.type_defendant === "fileUpload" && (
                                                <div className={styles.defendant_card_header}>
                                                    <div className={styles.defendant_card_second_div} >
                                                        <input
                                                            type="file"
                                                            id="file-upload"
                                                            className={styles.file_upload_input}
                                                            onChange={(event) => handleFileAndDefendantChange(event, defendant.id)}
                                                        />
                                                        <label htmlFor="file-upload" className={styles.file_upload_label}>
                                                            {defendantsData.find(item => item.defendantId === defendant.id)?.file?.name || 'Загрузите изображение'}
                                                        </label>
                                                    </div>
                                                </div>
                                            )}

                                        </>
                                    )}
                                    {defendant.file &&
                                        <img
                                            src={defendant.file}
                                            className={styles.img_file}
                                        />
                                    }
                                </div>

                            </>
                        ))}
                         {item.comment ?
                             <div style={{ marginTop: '10px', display:'flex', flexDirection:'row', alignItems:'center', gap:'10px'}}>
                                
                                <DraftContent draftData={item.comment} />

                            </div> : null
                        }
                        {(item.type_defendant !== 'infoText') &&
                            <>

                                {Number(item_selected) !== Number(item.id) &&
                                    <div className={styles.defendant_card_selection_footer}>


                                        <button
                                            style={{
                                                padding: "5px 10px 5px 10px",
                                                fontSize: "14px",
                                                color: "#fff",
                                                border: "none",
                                                background: "#003BFF",
                                                borderRadius: "5px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => handleSubmit(item.id)}
                                        >
                                            Отправить ответ
                                        </button>


                                    </div>
                                }

                            </>
                        }
                       
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <h4 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {t('auto.components_partsurveyitemused.k1')}
                    </h4>
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartSurveyItemUsed;
